import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnfoldLess = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-224.00 -348.44 1600.00 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1065 201 1015 151Q1005 141 992.0 141.0Q979 141 969 151L576 544L183 151Q173 141 160.0 141.0Q147 141 137 151L87 201Q77 211 77.0 224.0Q77 237 87 247L553 713Q563 723 576.0 723.0Q589 723 599 713L1065 247Q1075 237 1075.0 224.0Q1075 211 1065 201ZM1065 585 1015 535Q1005 525 992.0 525.0Q979 525 969 535L576 928L183 535Q173 525 160.0 525.0Q147 525 137 535L87 585Q77 595 77.0 608.0Q77 621 87 631L553 1097Q563 1107 576.0 1107.0Q589 1107 599 1097L1065 631Q1075 621 1075.0 608.0Q1075 595 1065 585Z"
	})
});
export default SvgUnfoldLess;
